// Google Analytics 4 utility functions

const MEASUREMENT_ID = 'G-6LM7YN5P1R';

// Track page views
export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Common event tracking functions
export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location,
  });
};

export const trackFormSubmission = (formName) => {
  trackEvent('form_submit', {
    form_name: formName,
  });
};

export const trackLinkClick = (linkText, linkUrl) => {
  trackEvent('link_click', {
    link_text: linkText,
    link_url: linkUrl,
  });
};

